module.exports = __webpack_public_path__ + "static/transdev-00-hero-2e806d8748c28588a8999afb5b2f914b.jpg";